import { Pipe, PipeTransform } from '@angular/core';
import { first, get, isEmpty } from 'lodash';

@Pipe({
  name: 'modifyFontSizePrint',
})
export class ModifyFontSizePrintPipe implements PipeTransform {
  transform(fontSize: any, forPrintInd: any, event: any): string {
    if (!forPrintInd) {
      return fontSize + 'px';
    }
    if (event.customEvent) {
      const customHTML = event.customHTML;
      const customFontSize = this.getPrintFontSize(customHTML);
      if (customFontSize) {
        return parseInt(customFontSize) / 0.75 + 'px';
      }
    }
    return parseInt(fontSize) / 0.75 + 'px';
  }

  getPrintFontSize(value: any): string | null {
    if (isEmpty(value)) return null;
    const regularExpression = /font-size:\s*\d*\.?\d*\s*px;?/g;
    const fontSize = get(value.match(regularExpression), '0', null);
    if (isEmpty(fontSize)) return null;
    const matches = get(fontSize.match(/\d+/g), '0', null);
    if (isEmpty(matches)) return null;
    return matches;
  }
}
